import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { acceptOneRentAsset } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateAcceptOneRentAsset = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const {
		mutate: acceptProposedAsset,
	} = useMutation<{ assetId: string }>({
		mutationKey: [ASSET_RENT_REQUEST_CARD_ITEMS, id],
		mutationFn: ({ assetId }: { assetId: string }) => acceptOneRentAsset(assetId),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentAcceptProposalItem,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return { acceptProposedAsset };
};
